//
//
//
//
//
//

export default {
  name: "DescriptionProductCard"
}
